import { Component, OnInit } from '@angular/core';
import {Platform} from "@angular/cdk/platform";
import {MatDialog} from "@angular/material/dialog";
import {UrlService} from "@utils/services/url/url.service";
import {GetAppDialogComponent} from "@lib-modules/dialogs/components/get-app-dialog/get-app-dialog.component";
import {MatchBannerService} from "@lib-modules/match/services/match-banner/match-banner.service";

@Component({
  selector: 'lib-match-top-banner',
  templateUrl: './match-top-banner.component.html',
  styleUrls: ['./match-top-banner.component.scss']
})
export class MatchTopBannerComponent implements OnInit {

  public link: string;
  public routerLink: string;

  constructor( public matchBannerService: MatchBannerService,
               private platform: Platform,
               private matDialog: MatDialog ) { }

  public ngOnInit(): void {
    this.matchBannerService.init();
    if (this.platform.ANDROID) {
      this.link = UrlService.PlayStoreLink;
    }
    if (this.platform.IOS) {
      this.link = UrlService.AppStoreLink;
    }
  }

  public openGetAppDialog(): void {
    this.matDialog.open(GetAppDialogComponent, GetAppDialogComponent.config);
  }

}
